export default __webpack_public_path__ + "static/media/edge-desktop-1.9d866691.png";